export const normalizeTaxIds = (productOrState) => {
  if (Array.isArray(productOrState?.taxIds)) {
    const seen = new Set();
    return productOrState.taxIds
      .map(Number)
      .filter((id) => Number.isFinite(id) && id > 0)
      .filter((id) => {
        if (seen.has(id)) return false;
        seen.add(id);
        return true;
      });
  }

  const legacy = Number(
    productOrState?.taxDetails?.taxId ??
      productOrState?.taxId ??
      productOrState?.Tax ??
      productOrState?.selectedTax
  );

  return Number.isFinite(legacy) && legacy > 0 ? [legacy] : [];
};

export const normalizeRateDecimal = (raw) => {
  const n = Number(raw);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return n > 1 ? n / 100 : n;
};

export const findTaxOptionById = (taxOptions = [], taxId = null) => {
  if (taxId == null || taxId === "") return null;

  return (
    (Array.isArray(taxOptions) ? taxOptions : []).find(
      (tax) => String(tax?.id ?? tax?.taxId) === String(taxId)
    ) || null
  );
};

// Edit Product writes through several legacy tax aliases. Keep that write atomic so
// readers which have not yet migrated to taxDetails cannot observe a stale tax.
export const buildProductTaxPatch = (selectedTax = null) => {
  const rawTaxId = selectedTax?.taxId ?? selectedTax?.id ?? null;
  const numericTaxId = Number(rawTaxId);
  const taxId = rawTaxId == null || rawTaxId === ""
    ? null
    : Number.isFinite(numericTaxId) ? numericTaxId : rawTaxId;
  const taxDetails = taxId == null
    ? null
    : { ...selectedTax, taxId };

  return {
    Tax: taxId,
    tax: taxId,
    taxId,
    selectedTax: taxId != null ? String(taxId) : "",
    taxIds: taxId != null ? [taxId] : [],
    TaxIds: taxId != null ? [taxId] : [],
    taxDetails,
  };
};

export const resolveTaxRateFromOption = (taxOptions = [], taxId = null) => {
  const option = findTaxOptionById(taxOptions, taxId);
  return normalizeRateDecimal(option?.value ?? option?.rate ?? option?.Rate);
};

export const buildPromoStoreTaxState = (source = {}, taxOptions = []) => {
  const taxIds = normalizeTaxIds(source);
  const firstTaxId = taxIds.length ? taxIds[0] : null;
  const optionRate = resolveTaxRateFromOption(taxOptions, firstTaxId);
  const fallbackRate = normalizeRateDecimal(
    source?.selectedTaxRate ??
      source?.taxDetails?.value ??
      source?.taxDetails?.rate ??
      source?.taxRate?.value
  );
  const selectedTaxRate =
    firstTaxId == null ? null : optionRate || fallbackRate || null;

  return {
    selectedTax: firstTaxId != null ? String(firstTaxId) : "",
    selectedTaxRate,
    taxId: firstTaxId,
    taxIds,
    Tax: firstTaxId != null ? String(firstTaxId) : null,
  };
};
